<template>
    <div>
        <Row :gutter="8">
            <Col span="4">
                <Input v-model="title" type="text" placeholder="技能培训主题" clearable @on-clear="getList" />
            </Col>
            <Col span="18">
                <Button type="primary" icon="ios-search" @click="search">查询</Button>
                <Button type="success" icon="md-add" code="cscp.skill.add" @click="jump('skillAdd', {action: 'add'})">新增</Button>
                <Button code="cscp.user.import" type="primary" ghost icon="ios-cloud-upload-outline" style="margin-right: 10px;" @click="importShow = true">导入</Button>
            </Col>
        </Row>
        <Row>
            <Col span="24">
                <Table 
                    border 
                    ref="table"
                    size="small" 
                    :columns="columns" 
                    :data="tableData" 
                    :height="tableHeight"
                ></Table>
            </Col>
        </Row>
        <Row>
            <Col span="24" style="text-align:center;">
                <Page 
                    :total="total" 
                    :page-size="pageSize" 
                    :current="pageNumber" 
                    show-elevator 
                    show-sizer 
                    show-total 
                    @on-change="pageChange"
                    @on-page-size-change="pageSizeChange"
                />
            </Col>
        </Row>
        <import-user-modal v-model="importShow"></import-user-modal>
        <record-modal v-model="recordShow" title="技能培训总结" :id="recordId"></record-modal>
        <order-sign v-model="orderShow" title="预约签到" :id="orderId"></order-sign>
    </div>
</template>

<script>
import QRCode from 'qrcode'

export default {
    name: "skillActivity",
    data() {
        return {
            // 搜索内容
            title: '',
            importShow: false,
            // 表格配置
            columns: [{
                type: 'selection',
                width: 60,
                fixed: 'left',
                align: 'center'
            }, {
                title: '技能培训主题',
                key: 'title',
                align: 'center',
                tooltip: true
            }, {
                title: '技能培训地点',
                key: 'place',
                align: 'center',
            }, {
                title: '开始时间',
                key: 'startDate',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.dayjs(params.row.startDate).format('YYYY-MM-DD HH:mm'));
                }
            }, {
                title: '结束时间',
                key: 'endDate',
                align: 'center',
                render: (h, params) => {
                    return h('span', this.dayjs(params.row.endDate).format('YYYY-MM-DD HH:mm'));
                }
            }, {
                title: '技能培训总人数',
                key: 'reserveNum',
                align: 'center'
            }, {
                title: '已预约人数',
                key: 'reservedNumber',
                align: 'center'
            }, {
                title: '操作',
                width: 400,
                fixed: 'right',
                align: 'center',
                render: (h, params) => {
                    return h('ButtonGroup', {
                        props: {
                            size: 'small'
                        }
                    }, [
                        h('Button', {
                            props: {
                                type: 'info',
                                code: 'cscp.skill.detail'
                            },
                            on: {
                                click: () => {
                                    let param = {
                                        action: 'detail',
                                        id: params.row.id
                                    }
                                    this.jump('skillDetail', param)
                                }
                            }
                        }, '查看'),
                        h('Button', {
                            props: {
                                type: 'success',
                                code: 'cscp.skill.edit'
                            },
                            on: {
                                click: () => {
                                    let param = {
                                        action: 'edit',
                                        id: params.row.id
                                    }
                                    this.jump('skillEdit', param)
                                }
                            }
                        }, '修改'),
                        h('Button', {
                            props: {
                                type: 'warning',
                                code: 'cscp.skill.delete'
                            },
                            on: {
                                click: () => {
                                    this.openDeleteModal(params.row.id);
                                }
                            }
                        }, '删除'),
                        h('Button', {
                            props: {
                                code: 'cscp.skill.qrcode'
                            },
                            on: {
                                click: () => {
                                    QRCode.toDataURL(params.row.id.toString(), { width: 400, height: 400 }).then(url => {
                                        let a = document.createElement('a');
                                        a.href = url;
                                        a.setAttribute('download', '签到二维码');
                                        a.click();
                                    }).catch(err => {
                                        this.$Message.error('下载签到二维码失败');
                                    })
                                }
                            }
                        }, '下载二维码'),
                        h('Button', {
                            props: {
                                code: 'cscp.skill.summary'
                            },
                            on: {
                                click: () => {
                                    this.recordId = params.row.id.toString();
                                    this.recordShow = true;
                                }
                            }
                        }, '技能培训总结'),
                        h('Button', {
                            props: {
                                code: 'cscp.skill.join'
                            },
                            on: {
                                click: () => {
                                    this.orderId = params.row.id.toString();
                                    this.orderShow = true;
                                }
                            }
                        }, '预约签到')
                    ])
                }
            }],
            // 表格数据
            tableData: [],
            // 表格高度
            tableHeight: 500,
            // 分页条
            total: 0,
            pageNumber: 1,
            pageSize: 10,
            // 技能培训总结弹窗显示
            recordShow: false,
            recordId: '',
            // 预约签到弹窗显示
            orderShow: false,
            orderId: ''
        };
    },
    components: {
        'import-user-modal': () => import('./import-skill-modal.vue'),
        'record-modal': () => import('@/views/party-build/meeting/record-modal.vue'),
        'order-sign': () => import('@/views/party-build/volunteer/order-sign.vue')
    },
    created() {
        this.getList();
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 220;
    },
    watch: {
        importShow(newV) {
            if (!newV) {
                this.getList()
            }
        }
    },
    methods: {
        /**
         * @description 请求列表
         */
        getList() {
            let msg = this.$Message.loading({
                content: '正在获取数据',
                duration: 0
            })
            let params = {
                'title.contains': this.title,
                'villageActivityType.contains': '3',
                page: this.pageNumber - 1,
                size: this.pageSize,
            }
            this.$http.get('/api/activitysByCriteria', {params: params}).then(res => {
                msg();
                if(res.data.code == 0) {
                    this.tableData = res.data.datas;
                    this.total = res.data.totalCount;
                }else{
                    this.$Message.error(res.data.message);
                }
            }).catch(err => {
                msg();
            })
        },
        /**
         * @description 查询列表
         */
        search() {
            this.pageNumber = 1;
            this.getList();
        },
        /**
         * @description 分页页数改变
         */
        pageChange(pageNumber) {
            this.pageNumber = pageNumber
            this.getList();
        },
        /**
         * @description 分页每页条数改变
         * @description 重置页码为1
         */
        pageSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.pageNumber = 1;
            this.getList();
        },
        /**
         * @description 删除弹框
         */
        openDeleteModal(id) {
            this.$Modal.confirm({
                title: '提示',
                content: '确认删除该选项？',
                onOk: () => {
                    this.deleteMeeting(id)
                }
            });
        },
        /**
         * @description 删除
         */
        deleteMeeting(id) {
            this.$http.delete('/api/meetingActivitys/' + id).then(res => {
                if(res.data.code == 0) {
                    this.$Message.success('删除成功');
                    let totalPage = Math.ceil((this.total - 1) / this.pageSize);
                    this.pageNumber = this.pageNumber > totalPage ? totalPage : this.pageNumber;
                    this.getList();
                }else{
                    this.$Message.error(res.data.message);
                }
            })
        }
    }
};
</script>

<style lang="less" scoped>
Button{
    margin-right: 4px;
}
.ivu-row{
    margin-bottom: 10px;
}
</style>
